
export const toIST = (date) => {
    var currentOffset = date.getTimezoneOffset();
    var istOffset = 330;
    var istTime = new Date(date.getTime() + (istOffset + currentOffset)*60000);
    var istTimeWithoutTZ = new Date(istTime.getTime() - (istTime.getTimezoneOffset() * 60000 ));
    return istTimeWithoutTZ;
}

export const dateString = (date) => {
    return date.toISOString().split("T")[0];
}
 
export const dateTimeString = (date) => {
    return date.toISOString();
}

export const startOfDay = (dateString) => {
    return dateString.split("T")[0] + "T00:00";
}

export const endOfDay = (dateString) => {
    return dateString.split("T")[0] + "T23:59";
}